<div class="flexColumnContainer">
  @if (chosenUser) {
    <app-user-card [user]="chosenUser" [selected]="true"
                   (userDeselected)="deselectUser()"></app-user-card>
  }
  @if (!chosenUser && canSelectUser && !newUser) {
    <form class="flexColumnContainer"
          [formGroup]="searchUserFormGroup">
      <mat-form-field id="userSelectionFormField" appearance="outline">
        <mat-label class="body-large">{{ 'userSelection.searchUser.label' | translate }}</mat-label>
        <input type="text" class="body-large"
               [placeholder]="'userSelection.searchUser.placeholder' | translate"
               aria-label="Search for user"
               matInput
               [formControl]="searchUserFormControl"
               [matAutocomplete]="auto">
        <mat-icon class="material-icons-outlined" matPrefix>person_search</mat-icon>
        @if (loadingSearchResult) {
          <mat-spinner id="searchFormsSpinner" diameter="30" matSuffix></mat-spinner>
        }
        <mat-autocomplete class="body-large" autoActiveFirstOption #auto="matAutocomplete"
                          (optionSelected)="selectUser($event.option.value)">
          @for (user of filteredUsers | async; track user) {
            <mat-option [value]="user">
              <app-user-card [user]="user"/>
            </mat-option>
          }
          @if ((filteredUsers | async)?.length === 0) {
            <mat-option disabled>
              <span class="body-medium">{{ 'userSelection.emptyOption.label' | translate }}</span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <button mat-flat-button id="createNewUser"
              (click)="toggleNewUser()"
              [ngClass]="{collapsed: !canCreateUser}"
              aria-label="Create new user">
        <mat-icon class="material-icons-outlined">add</mat-icon>
        <span>{{ 'userSelection.buttons.createNewUser' | translate }}</span>
      </button>
    </form>
  }
  @if (!chosenUser && canCreateUser && newUser) {
    <form class="flexColumnContainer"
          [formGroup]="createUserFormGroup">
      <button id="searchForExistingUser" mat-button (click)="toggleNewUser()" [disabled]="creatingUser">
        <mat-icon class="material-icons-outlined">search</mat-icon>
        <span aria-label="Search for existing user">{{ 'userSelection.buttons.removeNewUser' | translate }}</span>
      </button>
      <mat-form-field id="emailFormField" appearance="outline">
        <mat-label>{{ 'userSelection.inputs.email.label' | translate }}</mat-label>
        <input type="email"
               [placeholder]="'userSelection.inputs.email.placeholder' | translate"
               aria-label="Email"
               matInput
               [formControl]="emailFormControl">
        @if (emailFormControl.hasError('required')) {
          <mat-error>{{ 'userSelection.inputs.email.requiredErrorMessage' | translate }}</mat-error>
        }
        @if (emailFormControl.hasError('email')) {
          <mat-error>{{ 'userSelection.inputs.email.formatErrorMessage' | translate }}</mat-error>
        }
      </mat-form-field>
      <div id="firstAndLastNameContainer" class="flexRowContainer">
        <mat-form-field id="firstNameFormField" appearance="outline">
          <mat-label>{{ 'userSelection.inputs.firstName.label' | translate }}</mat-label>
          <input type="text"
                 [placeholder]="'userSelection.inputs.firstName.placeholder' | translate"
                 aria-label="First name"
                 matInput
                 [formControl]="firstNameFormControl">
          @if (firstNameFormControl.hasError('required')) {
            <mat-error>{{ 'userSelection.inputs.firstName.requiredErrorMessage' | translate }}</mat-error>
          }
          @if (firstNameFormControl.hasError('maxlength')) {
            <mat-error>{{ 'userSelection.inputs.firstName.maxLengthErrorMessage' | translate }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field id="lastNameFormField" appearance="outline">
          <mat-label>{{ 'userSelection.inputs.lastName.label' | translate }}</mat-label>
          <input type="text"
                 [placeholder]="'userSelection.inputs.lastName.placeholder' | translate"
                 aria-label="Last name"
                 matInput
                 [formControl]="lastNameFormControl">
          @if (lastNameFormControl.hasError('required')) {
            <mat-error>{{ 'userSelection.inputs.lastName.requiredErrorMessage' | translate }}</mat-error>
          }
          @if (lastNameFormControl.hasError('maxlength')) {
            <mat-error>{{ 'userSelection.inputs.lastName.maxLengthErrorMessage' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'userSelection.inputs.additionalInfo.label' | translate }}</mat-label>
        <input type="text"
               [placeholder]="'userSelection.inputs.additionalInfo.placeholder' | translate"
               aria-label="Additional information"
               matInput
               maxlength="256"
               [formControl]="additionalInfoFormControl">
        @if (additionalInfoFormControl.hasError('maxlength')) {
          <mat-error>{{ 'userSelection.inputs.additionalInfo.maxLengthErrorMessage' | translate }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'userSelection.inputs.phone.label' | translate }}</mat-label>
        <input type="tel"
               [placeholder]="'userSelection.inputs.phone.placeholder' | translate"
               aria-label="Phone"
               matInput
               [formControl]="phoneFormControl">
        @if (phoneFormControl.hasError('maxlength')) {
          <mat-error>{{ 'userSelection.inputs.phone.maxLengthErrorMessage' | translate }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'userSelection.inputs.company.label' | translate }}</mat-label>
        <input type="text"
               [placeholder]="'userSelection.inputs.company.placeholder' | translate"
               aria-label="Company"
               matInput
               [formControl]="companyFormControl">
        @if (companyFormControl.hasError('maxlength')) {
          <mat-error>{{ 'userSelection.inputs.company.maxLengthErrorMessage' | translate }}</mat-error>
        }
      </mat-form-field>
      <button mat-flat-button id="createUser" (click)="createUser()" (keydown.enter)="createUser()"
              [disabled]="!emailFormControl.valid || !firstNameFormControl.valid || !lastNameFormControl.valid"
              aria-label="Create user">
        <mat-icon class="material-icons-outlined">add</mat-icon>
        <span>{{ 'userSelection.buttons.createUser' | translate }}</span>
      </button>
    </form>
  }
</div>
